import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, Link } from '@material-ui/core';

import useDashboard from '../../../../hooks/useDashboard';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
/* Modal */
import useStyles from '../../Main.style';
import { getLoggedInUserData } from '../../../../utils/Helper';

const DashboardGoals = ({ type }) => {
  /* Modal */
  const loggedInUserData = getLoggedInUserData();
  const userId = loggedInUserData?.id;

  const { getCompanyQuarterlyGoal, getMyQuarterlyGoal, getCellQuarterlyGoal } = useDashboard();
  const [quarterlyGoal, setQuarterlyGoal] = useState([]);

  const loadMyProfessionalQuarterlyGoalCompany = async () => {
    const companyQuarterlyGoal = await getCompanyQuarterlyGoal({
      userId: userId,
      partOf: '1',
      type: '1',
      year: '0.25',
    });
    setQuarterlyGoal(companyQuarterlyGoal?.data);
  };
  const loadMyProfessionalQuarterlyGoal = async () => {
    const myProfessionalQuarterlyGoals = await getMyQuarterlyGoal({
      userId,
      partOf: '3',
      type: '1',
      year: '0.25',
    });

    setQuarterlyGoal(myProfessionalQuarterlyGoals?.data);
  };
  const loadMyProfessionalQuarterlyGoalCell = async () => {
    const cellQuarterlyGoals = await getCellQuarterlyGoal({
      userId: loggedInUserData?.id,
      cellId: loggedInUserData?.cellId,
      partOf: '2',
      type: '1',
      year: '0.25',
    });

    setQuarterlyGoal(cellQuarterlyGoals?.data);
  };

  const getTitle = () => {
    if (type === 'summary') {
      return 'My Goals';
    } else if (type === 'company') {
      return "Vector's Goals";
    } else if (type === 'cell') {
      return "My Cell's Goals";
    }
    return '';
  };

  useEffect(() => {
    if (type === 'summary') {
      loadMyProfessionalQuarterlyGoal();
    } else if (type === 'company') {
      loadMyProfessionalQuarterlyGoalCompany();
    } else if (type === 'cell') {
      loadMyProfessionalQuarterlyGoalCell();
    }
  }, []);

  const classes = useStyles();
  return (
    <Box className={classes.innercontent} p={2} mt={4} mb={4} width={1}>
      <Grid container>
        {/* <Grid item xs={12}>
          <Box m={1} />
        </Grid> */}
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5">{getTitle()}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <If condition={quarterlyGoal?.dataQ1 != null}>
                    {' '}
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q1
                        </Typography>
                      </Box>
                      {quarterlyGoal?.dataQ1?.goals.slice(0, 5).map((goal, index) => (
                        <Box display="flex" mt={1}>
                          <Box display="flex" mr={1}>
                            <Typography variant="h5" noWrap>
                              {index + 1}.
                            </Typography>
                          </Box>
                          <Box display="flex">{goal || 'Goal not defined yet'}</Box>
                        </Box>
                      ))}
                      {/* <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            1.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {companyProfessionalQuarterlyGoal?.dataQ1?.goal1 ||
                            'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            2.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {companyProfessionalQuarterlyGoal?.dataQ1?.goal2 ||
                            'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            3.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {companyProfessionalQuarterlyGoal?.dataQ1?.goal3 ||
                            'Goal not defined yet'}
                        </Box>
                      </Box> */}
                    </Box>
                  </If>
                  <If condition={quarterlyGoal?.dataQ1 == null}>
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q1
                        </Typography>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          No goals set for the 1st quarter yet
                        </Box>
                      </Box>
                    </Box>
                  </If>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <If condition={quarterlyGoal?.dataQ2 != null}>
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q2
                        </Typography>
                      </Box>
                      {quarterlyGoal?.dataQ2?.goals.slice(0, 5).map((goal, index) => (
                        <Box display="flex" mt={1}>
                          <Box display="flex" mr={1}>
                            <Typography variant="h5" noWrap>
                              {index + 1}.
                            </Typography>
                          </Box>
                          <Box display="flex">{goal || 'Goal not defined yet'}</Box>
                        </Box>
                      ))}
                      {/* <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            1.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {companyProfessionalQuarterlyGoal?.dataQ2?.goal1 ||
                            'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            2.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {companyProfessionalQuarterlyGoal?.dataQ2?.goal2 ||
                            'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            3.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {companyProfessionalQuarterlyGoal?.dataQ2?.goal3 ||
                            'Goal not defined yet'}
                        </Box>
                      </Box> */}
                    </Box>
                  </If>
                  <If condition={quarterlyGoal?.dataQ2 == null}>
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q2
                        </Typography>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          No goals set for the 2nd quarter yet
                        </Box>
                      </Box>
                    </Box>
                  </If>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <If condition={quarterlyGoal?.dataQ3 != null}>
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q3
                        </Typography>
                      </Box>
                      {quarterlyGoal?.dataQ3?.goals.slice(0, 5).map((goal, index) => (
                        <Box display="flex" mt={1}>
                          <Box display="flex" mr={1}>
                            <Typography variant="h5" noWrap>
                              {index + 1}.
                            </Typography>
                          </Box>
                          <Box display="flex">{goal || 'Goal not defined yet'}</Box>
                        </Box>
                      ))}
                      {/* <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            1.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {companyProfessionalQuarterlyGoal?.dataQ3?.goal1 ||
                            'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            2.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {companyProfessionalQuarterlyGoal?.dataQ3?.goal2 ||
                            'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            3.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {companyProfessionalQuarterlyGoal?.dataQ3?.goal3 ||
                            'Goal not defined yet'}
                        </Box>
                      </Box> */}
                    </Box>
                  </If>

                  <If condition={quarterlyGoal?.dataQ3 == null}>
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q3
                        </Typography>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          No goals set for the 3rd quarter yet
                        </Box>
                      </Box>
                    </Box>
                  </If>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <If condition={quarterlyGoal?.dataQ4 != null}>
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q4
                        </Typography>
                      </Box>
                      {quarterlyGoal?.dataQ4?.goals.slice(0, 5).map((goal, index) => (
                        <Box display="flex" mt={1}>
                          <Box display="flex" mr={1}>
                            <Typography variant="h5" noWrap>
                              {index + 1}.
                            </Typography>
                          </Box>
                          <Box display="flex">{goal || 'Goal not defined yet'}</Box>
                        </Box>
                      ))}
                      {/* <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            1.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {companyProfessionalQuarterlyGoal?.dataQ4?.goal1 ||
                            'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            2.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {companyProfessionalQuarterlyGoal?.dataQ4?.goal2 ||
                            'Goal not defined yet'}
                        </Box>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          <Typography variant="h5" noWrap>
                            3.
                          </Typography>
                        </Box>
                        <Box display="flex">
                          {companyProfessionalQuarterlyGoal?.dataQ4?.goal3 ||
                            'Goal not defined yet'}
                        </Box>
                      </Box> */}
                    </Box>
                  </If>

                  <If condition={quarterlyGoal?.dataQ4 == null}>
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="h4" noWrap>
                          Q4
                        </Typography>
                      </Box>
                      <Box display="flex" mt={1}>
                        <Box display="flex" mr={1}>
                          No goals set for the 4th quarter yet
                        </Box>
                      </Box>
                    </Box>
                  </If>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="flex-end"
                height={1}
                mt={0.5}
              >
                <Box display="flex" justifyContent="flex-end" alignItems="center">
                  <Box>
                    <Link color="textPrimary" href="/#/app/goals">
                      <Typography variant="caption">View all</Typography>
                    </Link>
                  </Box>
                  <Box className={classes.ViewAll}>
                    <ArrowForwardIcon />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={12}></Grid> */}
      </Grid>
    </Box>
  );
};

export default DashboardGoals;
